import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment.prod';
import { response } from './interface';

@Injectable({
  providedIn: 'root'
})
export class HomeService {

  constructor(
    private http: HttpClient
  ) { }

  getCounts(barristerId){
    let params : HttpParams = new HttpParams().set('barristerId', barristerId);
    return this.http.get<response>(environment.url + "home/counts", {params : params});
  }

  getDiaryCounts(data){
    return this.http.post<response>(environment.url + "home/counts", data);
    
  }


  getCountDetails(type, barristerId){
    let params : HttpParams = new HttpParams().set("type", type).set("barristerId", barristerId);
    return this.http.get<response>(environment.url + "home/details", {params : params});
  }

  searchNow(data){
    return this.http.post<response>(environment.url + "home/search", data);
  }

  

}
